export enum ReportType {
  PERFORMANCE_REPORT = 'PERFORMANCE_REPORT',
  SSM_REPORT = 'SSM_REPORT'
}

export enum ReportStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export interface CategoryConfig {
  id: string
  metrics: string[]
}

export interface PerformanceReportConfig {
  reportName: string
  reportDesc?: string
  framework: string
  categories: CategoryConfig[]
  frequency: string
  dateFrom: string | null
  dateTo: string | null
  timePeriod: string | null
  isIncludeCPIAppendix: boolean
  isIncludePublicLabels: boolean
  type: string
}

export interface CreateReportRequest {
  name: string
  description?: string
  type: ReportType
  config: PerformanceReportConfig
}

export interface ReportResponse {
  id: string
  name: string
  description?: string
  type: ReportType
  config: PerformanceReportConfig
  status: ReportStatus
  error_message?: string
}

// Template types

export enum TemplateOrderBy {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC'
}

export interface CreateReportTemplateRequest {
  name: string
  description?: string | null
  type: ReportType
  config: PerformanceReportConfig
}

export interface UpdateReportTemplateRequest {
  name?: string | null
  description?: string | null
  config?: PerformanceReportConfig | null
}

export interface DuplicateReportTemplateRequest {
  name: string
  description?: string | null
}

export interface ReportTemplateNameExistsResponse {
  exists: boolean
}

export interface ReportTemplateListItem {
  id: string
  name: string
  description?: string | null
  type: ReportType
  created_by: string
  last_generated?: string | null
  created_at?: string | null
  is_scheduled: boolean
}

export interface ReportTemplateResponse {
  id: string
  name: string
  description?: string | null
  type: ReportType
  config: PerformanceReportConfig
  created_by: string
  last_generated?: string | null
  created_at?: string | null
  updated_at?: string | null
  schedule?: ReportScheduleInfo | null
}

export interface PaginatedReportTemplatesResponse {
  items: ReportTemplateListItem[]
  total: number
  page: number
  page_size: number
}

export interface ListTemplatesParams {
  page?: number
  page_size?: number
  type?: ReportType
  search?: string
  order_by?: TemplateOrderBy
  is_scheduled?: boolean
}

// Template scheduling types

export enum ScheduleInterval {
  ONE_HOUR = '1H',
  ONE_DAY = '1D',
  WEEKLY = '1W',
  MONTHLY = '1M',
  QUARTERLY = '3M',
  SEMI_ANNUAL = '6M',
  YEARLY = '1Y'
}

export interface ReportScheduleInfo {
  interval: ScheduleInterval
  start_date: string
  recipients: string[]
  created_by?: string
}

export interface StartReportScheduleRequest {
  interval: ScheduleInterval
  start_date: string
  recipients: string[]
}

// Template validation types

export enum ValidationErrorType {
  FRAMEWORK = 'FRAMEWORK',
  CATEGORY = 'CATEGORY',
  METRIC = 'METRIC'
}

export interface ConfigValidationError {
  type: ValidationErrorType
  id: string
  message: string
}

export interface ValidateTemplateConfigResponse {
  valid: boolean
  errors?: ConfigValidationError[]
}
